<!-- <ion-button lines="none" (click)="onClientSelect()">
  <smr-circle-text-avatar
    slot="start"
    [firstName]="client.getFirstName()"
    [lastName]="client.getLastName()"
  >
  </smr-circle-text-avatar>
  <div>
    <span>{{ client.getFirstName() }} {{ client.getLastName() }}</span>
    <br />
    <p style="text-overflow: ellipsis; overflow: hidden">
      <span *ngIf="client.getEmail()">
        {{ client.getEmail() }}
      </span>
      <ng-container *ngIf="client.getPhone2()">
        <br />
        <span>
          {{ client.getPhone2() }}
        </span>
      </ng-container>
    </p>
  </div>
</ion-button> -->

<ion-item
  tappable
  class="ion-no-padding"
  (click)="onClientSelect()"
  lines="none"
>
  <ion-avatar
    slot="start"
    class="avatar"
    *ngIf="
      client.profilePhoto == '' ||
      client.profilePhoto == null ||
      client.profilePhoto == undefined
    "
  >
    <smr-circle-text-avatar
      [firstName]="client.firstName"
      [lastName]="client.lastName"
    >
    </smr-circle-text-avatar>
  </ion-avatar>
  <ion-avatar
    slot="start"
    class="avatar"
    *ngIf="
      client.profilePhoto != '' &&
      client.profilePhoto != null &&
      client.profilePhoto != undefined
    "
  >
    <img
      style="height: 2.5rem; width: 2.5rem"
      #clientProfilePhoto
      [defaultImage]="THUMBNAIL_PHOTO_ROOT + '/' + client.profilePhoto"
      [lazyLoad]="BOOKING_PHOTO_ROOT + '/' + client.profilePhoto"
      errorImage="./assets/images/monster.png"
    />
  </ion-avatar>
  <div class="info-container">
    <ion-label>{{ client.firstName }} {{ client.lastName }}</ion-label>
    <div style="text-overflow: ellipsis; overflow: hidden" class="contact-info">
      <span>{{ client.getEmail() }}</span>
    </div>
    <ng-container *ngIf="client.getPhone2()">
      <span>
        {{ client.getPhone2() }}
      </span>
    </ng-container>
  </div>
</ion-item>
